<template>
  <div class="wrap">
    <v-card-text style="padding: 0px">
      <div class="md-layout wrapCon">
        <div
          v-for="item in simulationList"
          :key="item._id"
          :max-height="isMobile.isMobile ? '105 !important' : '220'"
          :height="isMobile.isMobile ? '105 !important' : '220'"
          :class="
            isMobile.isMobile
              ? 'modelClientWrap'
              : 'md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 modelClientWrap'
          "
          @click="gotoDetail(item)"
        >
          <v-card
            elevation="3"
            class="cardWrap"
            :max-height="isMobile.isMobile ? '105' : '220'"
            :height="isMobile.isMobile ? '105' : '220'"
          >
            <v-img
              :lazy-src="getimg(item)"
              :height="isMobile.isMobile ? '80px' : '190px'"
              :max-height="isMobile.isMobile ? '80px' : '190px'"
              max-width="100%"
              :src="getimg(item)"
              class="courseImg"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <div style="position: absolute; right: 3px; top: 3px; z-index: 7">
              <v-btn
                icon
                :color="item.isCollect ? 'red' : 'grey'"
                class="button"
                @click.stop="clickcollect(item)"
              >
                <span
                  class="material-icons"
                  :style="{ fontSize: isMobile.isMobile ? '20px' : '30px' }"
                  >favorite</span
                >
                <md-tooltip md-direction="top">点击收藏</md-tooltip>
              </v-btn>

              <v-btn
                icon
                color="#fff"
                v-if="tabIndex == 1 && item.apply_status == 3"
                @click.stop
                class="button"
              >
                <span
                  class="iconfont icon-yichehui1"
                  :style="{ fontSize: isMobile.isMobile ? '20px' : '30px' }"
                ></span>
                <md-tooltip md-direction="top">已撤回</md-tooltip>
              </v-btn>
              <v-btn
                icon
                color="#fff"
                @click.stop="backRelease(3, item)"
                v-if="tabIndex == 1 && item.apply_status == 1"
                class="button"
              >
                <span
                  class="iconfont icon-chehui"
                  :style="{ fontSize: isMobile.isMobile ? '20px' : '30px' }"
                ></span>
                <md-tooltip md-direction="top">撤回</md-tooltip>
              </v-btn>

              <v-btn
                icon
                color="#fff"
                @click.stop="editRelease(item)"
                v-if="tabIndex == 1"
                class="button"
              >
                <span
                  class="iconfont icon-bianji1"
                  :style="{ fontSize: isMobile.isMobile ? '18px' : '26px' }"
                ></span>
                <md-tooltip md-direction="top">编辑</md-tooltip>
              </v-btn>
            </div>
            <div class="maskingWrap">
              <div class="contentWrap">
                <div style="float: left; padding: 6px">
                  <p>版本号:{{ item.version }}</p>
                  <p>发行时间:{{ dateFormat(item.updated_at) }}</p>
                  <p>发布人:{{ item.creater }}</p>
                </div>
              </div>
              <div class="colorStyle">{{ item.project ? item.project.description : '' }}</div>
              <!-- <div class="iconWrap"> -->
              <!-- <span
                  v-for="(it, index) in item.tagAll"
                  :key="index"
                  @click.stop
                  :style="it.style"
                >
                
                  <md-tooltip md-direction="top">{{ it.name }}</md-tooltip>
             
                  </span
                > -->
              <!-- <span
                    @click.stop
                    style="
                        height: 16px;
                        width: 16px;
                        background-image:url('/w10.png');
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        image-rendering: -webkit-optimize-contrast;
                    "
                    >
                    <md-tooltip md-direction="top">windows版本</md-tooltip>
                    </span>

                    <span
                    @click.stop
                    style="
                        height: 17px;
                        width: 17px;
                        background-image: url('/vr.png');
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        image-rendering: -webkit-optimize-contrast;
                    "
                    >
                    <md-tooltip md-direction="top">VR版本</md-tooltip>
                    </span>

                    <span
                    @click.stop
                    style="
                        height: 17px;
                        width: 40px;
                        background-image: url('/webGL.png');
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        background-position-y: 0px;
                        image-rendering: -webkit-optimize-contrast;
                        "
                    >
                    <md-tooltip md-direction="top">WebGL版本</md-tooltip>
                    </span>

                    <span
                    @click.stop
                    style="
                        height: 17px;
                        width: 17px;
                        background-image: url('/az.png');
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        image-rendering: -webkit-optimize-contrast;
                    "
                    >
                    <md-tooltip md-direction="top">安卓版本</md-tooltip>
                    </span>

                    <span
                    @click.stop
                    style="
                        height: 17px;
                        width: 40px;
                        background-image: url('/zspace.png');
                        background-repeat: no-repeat;
                        background-size: 101% 100%;
                        background-position-y: 1px;
                        image-rendering: -webkit-optimize-contrast;
                    "
                    >
                    <md-tooltip md-direction="top">ZSpace版本</md-tooltip>
                    </span>

                    <span
                    @click.stop
                    style="
                        height: 13px;
                        width: 40px;
                        background-image: url('/km.png');
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        background-position-y: -1px;
                        image-rendering: -webkit-optimize-contrast;
                    "
                    >
                    <md-tooltip md-direction="top">KMAX版本</md-tooltip>
                    </span>

                    <span
                    @click.stop
                    style="
                        height: 16px;
                        width: 23px;
                        background-image: url('/dr.png');
                        border-left: 1px solid rgb(255, 255, 255);
                        padding-left: 4px;
                        background-repeat: no-repeat;
                        background-position-x: 15px;
                        background-position: 6px 1px;
                        background-size: 65% 89%;
                        image-rendering: -webkit-optimize-contrast;
                    "
                    >
                    <md-tooltip md-direction="top">单机模式</md-tooltip>
                    </span> -->
              <!-- </div> -->
            </div>
            <div class="titleNameWrap">
              <p class="titleName" :title="item.name">{{ item.name }}</p>
            </div>
          </v-card>
        </div>
      </div>
    </v-card-text>

    <!-- <Pagination
      :page.sync="pagination.page"
      :total="pagination.total"
      :items-per-page.sync="pagination.itemsPerPage"
      @refresh="findList"
      style="text-align: right"
    /> -->
    <div style="margin-top: 10px; margin-bottom: 20px">
      <div style="overflow: hidden" >
        <v-pagination
          prev-icon="fa fa-angle-left"
          next-icon="fa fa-angle-right"
          class="pagination"
          color="#4caf50"
          :value="pagination.page"
          :length="pageCount"
          @input="inputChange"
          circle
          :total-visible="7"
          :style="{float:!isMobile.isMobile?'right':''}"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination/index';
import { listSimulation, updateSort, updateSimulation, setcollect } from '@/api/simulation';
import moment from 'moment';
import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['isMobile']),
    pageCount() {
      return this.pagination.total
        ? Math.ceil(this.pagination.total / this.pagination.itemsPerPage)
        : 0;
    },
  },
  props: {
    tabIndex: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Pagination,
  },
  watch: {},
  data() {
    return {
      searchQuery: '',
      simulationList: [],
      // 分页
      pagination: {
        page: 1,
        itemsPerPage: 8,
        total: 0,
      },
      optionsValue: ['all'],
    };
  },
  created() {},
  mounted() {
    this.$emit('setcourseListLoading', true);
    this.findList();
    let _this = this;
    this.$EventBus.$on('queryList', () => {
      _this.findList();
    });
  },
  methods: {
    inputChange(e) {
      this.pagination.page = e;
      this.findList();
    },
    getimg(item) {
      let str = null;
      if (item.bannerImg && item.bannerImg.length > 0) {
        if (
          item.bannerImg[0].url.indexOf('.mp4') !== -1 &&
          item.bannerImg[0].hasOwnProperty('poster')
        ) {
          str = item.bannerImg[0].poster;
        } else {
          str = item.bannerImg[0].url;
        }
      } else {
        str = require('@/assets/img/log.png');
      }
      return str;
    },
    //撤回发布
    async backRelease(status, item) {
      const map = {
        1: '发布',
        2: '拒绝',
        3: '撤回',
      };
      let result = await Swal.fire({
        title: '提示',
        text: `确认${map[status]} 《${item.name}》？`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
        const data = Object.assign(item, { apply_status: status });
        updateSimulation(data).then(res => {
          this.$store.dispatch('global/showSuccessMsg', '操作成功');
          this.findList();
        });
      }
    },

    clickcollect(data) {
      let params = {
        isCollect: data.isCollect == 1 ? 0 : 1,
        date: new Date(),
        _id: data._id,
      };
      if (params.isCollect == 0) {
        var date = new Date(2022, 9 - 1, 30, 8, 30);
        params.date = date;
        // params.date.setHours(0); // 将小时部分设置为0
        // params.date.setMinutes(0); // 将分钟部分设置为0
        // params.date.setSeconds(0); // 将秒部分设置为0
        // params.date.setMilliseconds(0); // 将毫秒部分设置为0
      } else if (params.isCollect == 1) {
        params.date = new Date();
      }

      setcollect(params).then(res => {
        if (res.code == '200') {
          data.isCollect = data.isCollect == 1 ? 0 : 1;
          this.$notify({
            timeout: 1500,
            message: params.isCollect ? '收藏成功' : '取消收藏',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          // this.pagination.page = 1;
          this.findList();
        }
      });
    },
    //跳转页面
    gotoDetail(item) {
      let obj = {
        path: '/SimClassDetails',
        query: {
          _id: item._id,
          type: 'simclass',
          courseType: null,
        },
      };
      if (this.tabIndex == 0 || item.apply_status == 0) {
        obj.query.courseType = 'courseView';
        this.$router.push(obj);
        return;
      }

      obj.query.courseType = 'courseView';
      this.$router.push(obj);

      // var NewUrl = window.location.origin+'/simClassDetails';

      // window.open(NewUrl,'_blank','width=' + screen.width + ', height=' + screen.height + ', top=0, left=0, toolbar=no, menubar=no, location=no, status=no, help=no, center=yes, scrollbars=yes, resizable=yes, minmizebutton=yes, maxmizebutton=yes');
    },
    //修改发布
    editRelease(item) {
      let obj = {
        path: '/SimClassDetails',
        query: {
          _id: item._id,
          type: 'simclass',
          courseType: null,
        },
      };
      // this.courseType = 'courseEdit'
      obj.query.courseType = 'courseEdit';
      this.$router.push(obj);
    },

    //添加过滤条件
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.findList();
      }
    },
    setSearchQuery(data) {
      this.searchQuery = data;
      this.findList();
    },
    selectCard(data) {
      this.optionsValue = data;
      this.findList();
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    findList() {
      let obj = {
        status: '1',
        perPage: this.pagination.itemsPerPage,
        currentPage: this.pagination.page,
        refer: this.optionsValue[0] == '' ? 'all' : this.optionsValue[0] || '',
        majorGroup: this.optionsValue[1] == 'all' ? '' : this.optionsValue[1] || '',
        majorGroup2: this.optionsValue[2] == 'all' ? '' : this.optionsValue[2] || '',
        name: this.searchQuery || '',
        tab: this.tabIndex,
      };
      if (this.tabIndex == 0) {
        obj.status = '1';
      } else {
        obj.status = '1';
      }

      listSimulation(obj)
        .then(res => {
          this.$emit('setcourseListLoading', false);
          this.simulationList = res.data.rows;
          this.simulationList.forEach(item => {
            item.tagAll = [];
            item.tag &&
              item.tag.forEach(items => {
                if (items == 'PC') {
                  let obj = {
                    url: '../../../w10.png',
                    name: 'Window版本',
                    style: {
                      height: '16px',
                      width: '16px',
                      backgroundImage: 'url("/w10.png")',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: '100% 100%',
                      imageRendering: '-webkit-optimize-contrast',
                    },
                  };
                  item.tagAll.push(obj);
                } else if (items == 'VR') {
                  let obj = {
                    url: '../../../vr.png',
                    name: 'VR版本',
                    style: {
                      height: '17px',
                      width: '17px',
                      backgroundImage: 'url("/vr.png")',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: '100% 100%',
                      imageRendering: '-webkit-optimize-contrast',
                    },
                  };
                  item.tagAll.push(obj);
                } else if (items == 'WebGL') {
                  let obj = {
                    url: '../../../webGL.png',
                    name: 'WebGL版本',
                    style: {
                      height: '17px',
                      width: '40px',
                      backgroundImage: 'url("/webGL.png")',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: '100% 100%',
                      backgroundPositionY: '0px',
                      imageRendering: '-webkit-optimize-contrast',
                    },
                  };

                  item.tagAll.push(obj);
                } else if (items == 'Android') {
                  let obj = {
                    url: '../../../az.png',
                    name: '安卓版本',
                    style: {
                      height: '17px',
                      width: '17px',
                      backgroundImage: 'url("/az.png")',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: '100% 100%',
                      backgroundPositionY: '0px',
                      imageRendering: '-webkit-optimize-contrast',
                    },
                  };

                  item.tagAll.push(obj);
                } else if (items == 'ZSpace') {
                  let obj = {
                    url: '../../../zspace.png',
                    name: 'ZSpace',
                    style: {
                      height: '17px',
                      width: '40px',
                      backgroundImage: 'url("/zspace.png")',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: '100% 100%',
                      backgroundPositionY: '1px',
                      imageRendering: '-webkit-optimize-contrast',
                    },
                  };
                  item.tagAll.push(obj);
                } else if (items == 'KMAX') {
                  let obj = {
                    url: '../../../km.png',
                    name: 'KMAX版本',
                    style: {
                      height: '13px',
                      width: '40px',
                      backgroundImage: 'url("/km.png")',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: '100% 100%',
                      backgroundPositionY: '-1px',
                      imageRendering: '-webkit-optimize-contrast',
                    },
                  };

                  item.tagAll.push(obj);
                } else if (items == 'standalone') {
                  let obj = {
                    url: '../../../dr.png',
                    name: '单机模式',
                    style: {
                      height: '16px',
                      width: '23px',
                      backgroundImage: 'url("/dr.png")',
                      backgroundRepeat: 'no-repeat',
                      borderLeft: '1px solid rgb(255, 255, 255)',

                      backgroundPosition: ' 6px 1px',
                      backgroundSize: ' 65% 89%',
                      imageRendering: '-webkit-optimize-contrast',
                    },
                  };

                  item.tagAll.push(obj);
                }
              });
          });

          this.pagination.total = res.data.total;
        })
        .catch(err => {
          this.$emit('setcourseListLoading', false);
        });
    },
  },
};
</script>

<style scoped>
.wrap {
  width: 100%;
  height: auto;
}

.wrapCon {
  min-height: 490px;
}
.cardWrap {
  margin: 10px 0px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.cardWrap:hover .maskingWrap {
  opacity: 1;
}
/deep/ .courseImg .v-image__image {
  height: 100%;
  background-size: 100% 100%;
}
.courseImg {
  height: 100%;
}

.maskingWrap {
  text-indent: 2px;
  opacity: 0;
  position: absolute;
  transition: 0.5s;
  width: 100%;
  height: 85%;
  /* padding: 10px; */
  background-color: #000000a3;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.contentWrap {
  width: 100%;
  overflow: hidden;
  color: #fff;
  font-size: 13px;
}
.contentWrap p {
  margin-bottom: 5px;
}

.titleName {
  color: #000;
  font-size: 14px;
  margin-top: 6px;
  padding: 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.titleName a {
  font-size: 14px;
}
.iconWrap {
  width: 98%;
  line-height: auto;
  height: auto;
  position: absolute;
  bottom: 0;
  right: 5px;
  text-align: right;
}
.iconWrap span {
  margin: 0 5px;
  display: inline-block;
}

.modelClientWrap {
  padding-left: 10px;
  padding-right: 10px;
}
.md-content {
  width: 100%;
  max-height: 850px;
  overflow: auto;
}
.filterValue {
  width: 300px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 999;
}

.filterValue .v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.modelClientWrap {
  /* margin: 10px 0; */
  height: 245px;
  max-height: 245px;
  cursor: pointer;

  padding-right: 10px !important;
  padding-left: 10px !important;
}

.titleNameWrap {
  background: #fff;
  width: 100%;
  height: 15%;
  line-height: 15%;
  position: absolute;
  bottom: 0;
  text-align: center;
}

@media (max-width: 1160px) {
  .modelClientWrap {
    height: 160px !important;
  }

  .cardWrap {
    height: 160px !important;
  }

  .maskingWrap {
    height: 130px !important;
  }
  .courseImg {
    height: 130px !important;
  }
  .titleNameWrap {
    height: 30px !important;
    line-height: 30px !important;
  }
  .titleNameWrap p {
    height: 30px !important;
    line-height: 30px !important;
    margin-bottom: 0px;
    margin-top: 0px;
  }
}

@media (max-width: 850px) {
  .modelClientWrap {
    height: 130px !important;
  }

  .cardWrap {
    height: 130px !important;
  }
  .maskingWrap {
    height: 130px !important;
  }
  .editWrap {
    height: 100px !important;
  }
  .courseImg {
    height: 100px !important;
  }
  .titleNameWrap {
    height: 30px !important;
    line-height: 30px !important;
  }
  .titleNameWrap p {
    height: 30px !important;
    line-height: 30px !important;
    margin-top: 0px;
  }
}

@media (max-width: 750px) {
  .modelClientWrap {
    height: 100px !important;
  }

  .cardWrap {
    height: 100px !important;
  }
  .maskingWrap {
    height: 100px !important;
  }

  .courseImg {
    height: 80px !important;
  }
  .maskingWrap {
    height: 80px !important;
  }

  .editWrap {
    height: 110px !important;
  }

  .titleNameWrap {
    height: 30px !important;
    line-height: 30px !important;
  }
  .titleNameWrap p {
    height: 30px !important;
    line-height: 30px !important;
    font-size: 12px;
    margin-bottom: 0px;
    margin-top: 0px;
  }
}

@media (max-width:600px) {
 .button{
  width: 25px !important;
 }
  .wrapCon{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    align-content: flex-start;
  }
  .modelClientWrap {
    width: 50% !important;
    padding-right: 10px !important;
    padding-left: 10px !important;
    height: 115px !important;

  }

  
  .wrapCon .modelClientWrap:nth-child(1) {
    margin-top: 0px !important;
  }
  .wrapCon .modelClientWrap:nth-child(2) {
    margin-top: 0px !important;
  }

  .contentWrap>div>p{
    font-size: 8px;
  }
  .maskingWrap{
    height: 80px;
  }

  .titleName{
    margin-bottom: 0px;
    font-size: 10px;
    line-height: 25px !important;
    height: 25px  !important;
    margin-top: 0px;
  }
  
  .titleNameWrap{
    height: 25px;
    line-height: 25px;
  }
}

</style>